import { useEffect } from 'react';

const BASE = 'JSISCO';

const usePageTitle = (title) => {
  useEffect(() => {
    document.title = title ? `${title} — ${BASE}` : BASE;
    return () => { document.title = BASE; };
  }, [title]);
};

export default usePageTitle;
